import React from 'react';
import {
  getDetailCommonValidUrlParams,
  getCountriesActiveuserRevDownValidUrlParams,
  statsRevenueValidCfg,
  countriesRevenueValidCfg,
  hasShortLinkRatio,
} from '@intelligence/_config/urlPageValidCfg';
import { ActiveuerRevDownCom } from './Activeuser';

export default function Revenue(props: any) {
  const { tabType, pageId } = props;
  const isCoutriesPage = tabType === 'countries';
  const currentValidCfg = isCoutriesPage ? countriesRevenueValidCfg : statsRevenueValidCfg;
  const getValidUrlParams = isCoutriesPage ? getCountriesActiveuserRevDownValidUrlParams : getDetailCommonValidUrlParams;
  // 是否有短链接更新功能
  const hasUrlShortLink = isCoutriesPage ? hasShortLinkRatio.detailMobileCountriesRevenue : hasShortLinkRatio.detailMobileStatsRevenue;

  if (pageId !== 'revenue') {
    return null;
  }

  return (
    <ActiveuerRevDownCom
      {...props}
      enableRevenueScope
      hasUrlShortLink={hasUrlShortLink}
      isCoutriesPage={isCoutriesPage}
      currentValidCfg={currentValidCfg}
      getValidUrlParams={getValidUrlParams}
      chartSegment={'sum_revenue'}

    />
  );
}
